export const NAME_REGEX = /^\S+/;

export const PHONE_REGEX = /^((\+44(\s\(0\)\s|\s0\s|\s)?)|0)7\d{3}(\s)?\d{6}$/;

// in testing we support multiple countries so our teammates can go through the flow
const TESTING_PREFIXES = ["07", "\\+44", "\\+381", "\\+373"];
export const RELAXED_PHONE_REGEX = new RegExp(
  `^${TESTING_PREFIXES.map((p) => `(${p})`).join("|")}\\d+$`
);

// matches anyString@anyString.anyString
export const EMAIL_REGEX = /^\S+@\S+\.\S+$/;

export const POSTCODE_REGEX =
  /^([A-Za-z][A-Ha-hJ-Yj-y]?[0-9][A-Za-z0-9]? ?[0-9][A-Za-z]{2})$/;
